import { render, staticRenderFns } from "./ServiceProjectCard.vue?vue&type=template&id=1f374dda&scoped=true&"
import script from "./ServiceProjectCard.vue?vue&type=script&lang=ts&"
export * from "./ServiceProjectCard.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProjectCard.vue?vue&type=style&index=0&id=1f374dda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f374dda",
  null
  
)

export default component.exports